// extracted by mini-css-extract-plugin
export default {"party_subHeadline":"party_subHeadline_QMULc"};